/* @TODO: Should be moved to their respective slice subfolders */

export const QUARTERLY_TAX_RETURNS = {
    RECEIVE: 'QUARTERLY_TAX_RETURNS_RECEIVE',
    RECEIVE_FILES: 'QUARTERLY_TAX_RETURNS_RECEIVE_FILES',
    DOWNLOAD_RETURN_FILE: 'QUARTERLY_TAX_RETURNS_DOWNLOAD_RETURN_FILE',
    REMOVE_FILE: 'QUARTERLY_TAX_RETURNS_REMOVE_FILE',
    ACTIVATE_QUARTERLY_TAX_RETURN: 'ACTIVATE_QUARTERLY_TAX_RETURN',
    DELETE_QUARTERLY_TAX_RETURN: 'DELETE_QUARTERLY_TAX_RETURN',
    CREATE_AND_ACTIVATE_QUARTERLY_TAX_RETURN: 'CREATE_AND_ACTIVATE_QUARTERLY_TAX_RETURN',
    CREATE_QUARTERLY_TAX_RETURN: 'CREATE_QUARTERLY_TAX_RETURN',
    RECEIVE_QUARTERLY_TAX_RETURN: 'RECEIVE_QUARTERLY_TAX_RETURN',
}

export const USER_AGREEMENT = {
    REQUEST_DRAFT: 'USER_AGREEMENT_REQUEST',
    RECEIVE_DRAFT: 'USER_AGREEMENT_RECEIVE',
    ERROR_DRAFT: 'USER_AGREEMENT_ERROR',
    REQUEST_ACCEPTED: 'USER_AGREEMENT_ACCEPTED_REQUEST',
    RECEIVE_ACCEPTED: 'USER_AGREEMENT_ACCEPTED_RECEIVE',
    ERROR_ACCEPTED: 'USER_AGREEMENT_ACCEPTED_ERROR',
}

export const PROFILE = {
    RECEIVE_PROFILE: 'RECEIVE_PROFILE',
    REQUEST_PROFILE: 'REQUEST_PROFILE',
    SAVE_PROFILE: 'SAVE_PROFILE',
    UPDATE_AND_SAVE_PROFILE: 'UPDATE_AND_SAVE_PROFILE',
    ASSIGN_ACCOUNTANT: 'ASSIGN_ACCOUNTANT',
    SAVE_IS_SELF_EMPLOYED: 'SAVE_IS_SELF_EMPLOYED',
    SYNC_PROFILE: 'SYNC_PROFILE',
}

export const SOCIAL_SECURITY_PROFILE = {
    REQUEST: 'REQUEST_SOCIAL_SECURITY_PROFILE',
    RECEIVE: 'RECEIVE_SOCIAL_SECURITY_PROFILE',
}
